import type { Action, Reducer } from "@reduxjs/toolkit";
import {
    AppState,
    AppActionTypes,
    LOAD_APP,
    SHOW_APP,
    TOGGLE_MENU,
    SET_BREADCRUMB_STACK,
    SET_MENU_IS_EXPANDED,
    SET_GLOBAL_ERROR,
    SET_PAGE_ERROR,
    SET_MENU_ITEMS,
    SHOW_BANNER,
    DISMISS_BANNER
} from "./types";

const lastMenuExpansionStatus = localStorage.getItem("menu-expanded") != "0";

const initialState: AppState = {
    loading: true,
    activeBranch: "",
    menuItems: "loading",
    menuIsExpanded: lastMenuExpansionStatus,
    breadcrumbStack: [{ title: "Home" }],
    errors: {},
    user: {
        name: "",
        roles: [],
        effectiveTags: [],
        isDeveloper: false,
    },
    settings: {
        domainName: window.location.hostname,
    } as any,
    banner: null,
};

export const appReducer: Reducer<AppState, Action, AppState> = (
    state = initialState,
    action: AppActionTypes
): AppState => {
    switch (action.type) {
        case LOAD_APP:
            return {
                ...state,
                loading: true,
                user: action.user,
                settings: action.settings,
            }

        case SHOW_APP:
            return {
                ...state,
                loading: false,
                activeBranch: action.activeBranch,
                menuItems: action.menuItems,
                settings: action.settings,
            }

        case SET_MENU_ITEMS:
            return {
                ...state,
                menuItems: action.menuItems,
            }

        case TOGGLE_MENU:
            localStorage.setItem("menu-expanded", state.menuIsExpanded ? "0" : "1");

            return {
                ...state,
                menuIsExpanded: !state.menuIsExpanded
            }

        case SET_BREADCRUMB_STACK:
            return {
                ...state,
                breadcrumbStack: action.breadcrumbStack
            }

        case SET_MENU_IS_EXPANDED:
            localStorage.setItem("menu-expanded", action.value ? "1" : "0");

            return {
                ...state,
                menuIsExpanded: action.value
            }

        case SET_GLOBAL_ERROR:
            return {
                ...state,
                errors: {
                    ...state.errors,
                    global: action.error
                }
            }

        case SET_PAGE_ERROR:
            return {
                ...state,
                errors: {
                    ...state.errors,
                    page: action.error
                }
            }

        case SHOW_BANNER:
            return {
                ...state,
                ...action,
            }

        case DISMISS_BANNER:
            return {
                ...state,
                banner: null,
            }

        default:
            return state;
    }
}